






import {Component, Prop, Vue} from 'vue-property-decorator'
import ServiceMesh from '@/lib/serviceMesh'
import Utils from '@/utils'
import Img from '@/components/proxy/Image.vue'

@Component({
  components: {
    Img,
    Flex: Utils.loadComponent('proxy/Flex'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Chip: Utils.loadComponent('proxy/Chip'),
  },
  name: 'VehicleConfirmImage',
})
export default class VehicleConfirmImage extends Vue {
  @Prop() private vehicleType!: string

  get confirmImage() {
    return ServiceMesh.getConfirmationImage(this.vehicleType)
  }

}
